<div class="summary-step-container">
  <div class="summary-grid">
    <!-- Phases Column -->
    <div class="summary-column">
      <div class="summary-column-header">
        <h3 i18n="@@phases">Phases</h3>
        <app-gpd-button icon="add" type="text" (click)="startAdd('phase')"></app-gpd-button>
      </div>
      <dx-scroll-view>
        <dx-sortable
          class="summary-items"
          [data]="phases"
          handle=".drag-handle"
          [allowReordering]="!editState"
          (onReorder)="onReorder($event)"
          (onDragStart)="startReorder($event)"
          (onDragChange)="onDragMove($event)"
          dragTemplate="drag-template"
          group="project-config"
          [allowDropInsideItem]="true"
          dropFeedbackMode="push"
          (onAdd)="onReorder($event)"
          type="phase"
        >
          <div *dxTemplate="let item of 'drag-template'" class="drag-template">
            <div
              [innerHTML]="item.itemElement.outerHTML | safeHTML"
              [style.width.px]="item.itemElement.scrollWidth"
            ></div>
          </div>
          @for (phase of phases; track phase.id; let phaseIndex = $index) {
            <app-phase-project-config-node
              class="summary-item"
              [phase]="phase"
              [phases]="phases"
              [itemNumber]="phaseIndex + 1"
              [isEditing]="isEditing('phase', phaseIndex)"
              [isSelected]="phaseIndex === selectedPhaseIndex"
              [validationCallback]="getPhaseValidationCallback(phaseIndex)"
              (onStartEdit)="startEdit('phase', phaseIndex)"
              (onSave)="saveEdit($event, phase)"
              (onCancel)="cancelEdit()"
              (onDelete)="deleteItem('phase', phaseIndex)"
              (onPhaseClick)="onPhaseClick(phaseIndex)"
            ></app-phase-project-config-node>
          }
        </dx-sortable>
      </dx-scroll-view>
    </div>

    <!-- Milestones Column -->
    <div class="summary-column">
      <div class="summary-column-header">
        <h3 i18n="@@milestones">Milestones</h3>
        <app-gpd-button
          *ngIf="selectedPhase"
          icon="add"
          type="text"
          (click)="startAdd('milestone', selectedPhaseIndex!)"
        ></app-gpd-button>
      </div>

      <dx-scroll-view>
        <dx-sortable
          class="summary-items"
          [data]="selectedPhase?.milestones || []"
          handle=".drag-handle"
          [allowReordering]="!editState"
          (onReorder)="onReorder($event)"
          (onDragStart)="startReorder($event)"
          (onDragChange)="onDragMove($event)"
          dragTemplate="drag-template"
          group="project-config"
          [allowDropInsideItem]="true"
          dropFeedbackMode="push"
          (onAdd)="onReorder($event)"
          type="milestone"
        >
          <div *dxTemplate="let item of 'drag-template'" class="drag-template">
            <div
              [innerHTML]="item.itemElement.outerHTML | safeHTML"
              [style.width.px]="item.itemElement.scrollWidth"
            ></div>
          </div>
          @for (milestone of selectedPhase?.milestones || []; track milestone.id; let milestoneIndex = $index) {
            <app-milestone-project-config-node
              class="summary-item"
              [milestone]="milestone"
              [phases]="phases"
              [itemNumber]="milestoneIndex + 1"
              [isEditing]="isEditing('milestone', selectedPhaseIndex!, milestoneIndex)"
              [isSelected]="milestoneIndex === selectedMilestoneIndex"
              [validationCallback]="getMilestoneValidationCallback(selectedPhaseIndex!, milestoneIndex)"
              (onStartEdit)="startEdit('milestone', selectedPhaseIndex!, milestoneIndex)"
              (onSave)="saveEdit($event, milestone)"
              (onCancel)="cancelEdit()"
              (onDelete)="deleteItem('milestone', selectedPhaseIndex!, milestoneIndex)"
              (onMilestoneClick)="onMilestoneClick(milestoneIndex)"
            ></app-milestone-project-config-node>
          }
        </dx-sortable>
      </dx-scroll-view>
      <!-- Add new milestone -->
    </div>

    <!-- Work Packages Column -->
    <div class="summary-column">
      <div class="summary-column-header">
        <h3 i18n="@@taskPackages">Task Packages</h3>
        <app-gpd-button
          *ngIf="selectedPhase && selectedMilestone"
          icon="add"
          type="text"
          (click)="startAdd('task', selectedPhaseIndex!, selectedMilestoneIndex!)"
        ></app-gpd-button>
      </div>
      <dx-scroll-view>
        <dx-sortable
          class="summary-items"
          [data]="selectedMilestone?.taskPackages || []"
          handle=".drag-handle"
          [allowReordering]="!editState"
          (onReorder)="onReorder($event)"
          (onDragStart)="startReorder($event)"
          (onDragChange)="onDragMove($event)"
          dragTemplate="drag-template"
          group="project-config"
          dropFeedbackMode="push"
          type="task-package"
        >
          <div *dxTemplate="let item of 'drag-template'" class="drag-template">
            <div
              [innerHTML]="item.itemElement.outerHTML | safeHTML"
              [style.width.px]="item.itemElement.scrollWidth"
            ></div>
          </div>
          @for (taskPackage of selectedMilestone?.taskPackages || []; track taskPackage.id; let taskIndex = $index) {
            <app-task-package-project-config-node
              class="summary-item"
              [taskPackage]="taskPackage"
              [phases]="phases"
              [itemNumber]="taskIndex + 1"
              [isEditing]="isEditing('task', selectedPhaseIndex!, selectedMilestoneIndex!, taskIndex)"
              [validationCallback]="getTaskValidationCallback(selectedPhaseIndex!, selectedMilestoneIndex!, taskIndex)"
              (onStartEdit)="startEdit('task', selectedPhaseIndex!, selectedMilestoneIndex!, taskIndex)"
              (onSave)="saveEdit($event, taskPackage)"
              (onCancel)="cancelEdit()"
              (onDelete)="deleteItem('task', selectedPhaseIndex!, selectedMilestoneIndex!, taskIndex)"
            ></app-task-package-project-config-node>
          }
        </dx-sortable>
      </dx-scroll-view>
      <!-- Add new task package -->
    </div>
  </div>
</div>
<dx-validator [adapter]="milestoneAdapterConfig">
  <dxi-validation-rule
    type="custom"
    [validationCallback]="summaryValidationCallback"
    [reevaluate]="true"
    i18n-message="@@milestoneConfigInvalidValidationMessage"
    message="Milestone configuration is invalid"
    style="display: none"
  ></dxi-validation-rule>
</dx-validator>
